// import iNoBounce from 'inobounce';
const var_name = 'overflow_hidden_modules';
class General {
  static init() {
    sessionStorage.removeItem(var_name);
    window.eventBodyOverflowHiddenController = new Event(
      'bodyOverflowHiddenController'
    );
  }

  static bodyOverflowHiddenController(
    module_name = false,
    add = false,
    event = true
  ) {
    if (module_name) {
      const class_name = 'overflow--hidden';
      const class_name2 = 'is-locked';
      const $_body = document.querySelector('body');
      let modules = JSON.parse(sessionStorage.getItem(var_name)) || [];
      // let modules = [];

      // $_body.style.top = `-${window.scrollY}px`;

      if (add && !modules.includes(module_name)) {
        modules.push(module_name);
      } else {
        modules = modules.filter((item) => item !== module_name);
      }

      if (modules.length && !$_body.classList.contains(class_name)) {
        document.documentElement.classList.add(class_name2);
        $_body.classList.add(class_name);
        // } else if (!modules.length && $_body.classList.contains(class_name)) {
      } else if (!modules.length) {
        $_body.classList.remove(class_name);
        document.documentElement.classList.remove(class_name2);
      }
      sessionStorage.setItem(var_name, JSON.stringify(modules));
      if (event) {
        document.dispatchEvent(window.eventBodyOverflowHiddenController);
      }
    } else {
      sessionStorage.removeItem(var_name);
    }
  }

  static randHex(len) {
    var maxlen = 32,
      min = Math.pow(16, Math.min(len, maxlen) - 1),
      max = Math.pow(16, Math.min(len, maxlen)) - 1,
      n = Math.floor(Math.random() * (max - min + 1)) + min,
      r = n.toString(16);
    while (r.length < len) {
      r = r + General.randHex(len - maxlen);
    }
    return r;
  }

  static toggleViewPort = (blockScale = true) => {
    let viewportContent = document.querySelector('meta[name=viewport]').content;
    if (blockScale) {
      viewportContent = `${viewportContent},user-scalable=0`;
    } else {
      viewportContent = viewportContent.replace(',user-scalable=0', '');
    }
    document
      .querySelector('meta[name=viewport]')
      .setAttribute('content', viewportContent);
  };

  static toggleDocumentLock = (
    module_name = false,
    add = false,
    event = true
  ) => {
    const toogleClassDocument = (modules = false) => {
      const class_name = 'is-locked';

      if (
        ((modules && modules.length) || modules === false) &&
        !document.documentElement.classList.contains(class_name)
      ) {
        // console.log('class_name', class_name, modules, document.documentElement.classList.contains(class_name));
        document.documentElement.classList.add(class_name);
        // iNoBounce.disable();
      } else if (
        ((modules && !modules.length) || modules === false) &&
        document.documentElement.classList.contains(class_name)
      ) {
        document.documentElement.classList.remove(class_name);
      }
    };

    if (module_name) {
      const var_name = 'document-lock';
      let modules = JSON.parse(sessionStorage.getItem(var_name)) || [];
      // let modules = [];

      if (add && !modules.includes(module_name)) {
        modules.push(module_name);
      } else {
        modules = modules.filter((item) => item !== module_name);
      }

      toogleClassDocument(modules);

      sessionStorage.setItem(var_name, JSON.stringify(modules));
      // if (event) {
      //     document.dispatchEvent(window.eventBodyOverflowHiddenController);
      // }
    } else {
      toogleClassDocument();
      // sessionStorage.removeItem(var_name);
    }
  };

  static debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };

  static getMobileOS = () => {
    const ua = navigator.userAgent;
    if (/android/i.test(ua)) {
      return 'Android';
    } else if (
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    ) {
      return 'iOS';
    }
    return 'Other';
  };
}
export default General;
